import React from "react";
import PdfDiffLab from "./PdfDiffLab";

export default function ToolPage() {
  return <PdfDiffLab />;
}
